import { PegaPlantaoToolbar } from './PegaPlantaoToolbar'
import { PegaPlantaoSearchComponent } from './PegaPlantaoSearchComponent'

export const PegaPlantaoHeader = () => {
  return (
    <div className='card-header border-0 pt-6'>
      <PegaPlantaoSearchComponent actions={<PegaPlantaoToolbar />} />
    </div>
  )
}
